import { STREAM_TYPES } from './constants';
import { StreamType } from './enums';

type Named = {
  gradYear: number;
  type: StreamType;
  groupName: string;
  groupCode: string;
};

const typeNames = (type: StreamType) => STREAM_TYPES.find(({ value }) => value === type);

/** A stream's name, e.g. "2026 Accelerated Chatswood". */
export const formatStreamLabel = (stream: Named): string =>
  `${stream.gradYear} ${typeNames(stream.type)?.label ?? ''} ${stream.groupName}`;

/**
 * A stream's name where space is short, e.g. "26 Acc CHS". Only the group's
 * code is the admin's to pick; the year and type follow the stream.
 */
export const formatStreamShortLabel = (stream: Named): string =>
  `${String(stream.gradYear % 100).padStart(2, '0')} ${typeNames(stream.type)?.shortLabel ?? ''} ${stream.groupCode}`;
